<template>
<section class="footer-wrapper">
  <section class="footer">
    <ul class="one list">
      <li class="title" s18n-common="">我们的服务</li>
      <li class="text">软件与技术服务</li>
      <li class="text">人工智能</li>
      <li class="text">大数据中心</li>
      <li class="text">5G新基建</li>
      <li class="text">工业互联网</li>
      <li class="text">云计算</li>
      <li class="text">行业整体解决方案</li>
      <li class="text"><router-link to="/service">更多服务>></router-link></li>
    </ul>
    <ul class="two list">
      <li class="title" s18n-common="">行业解决方案</li>
      <li class="text">银行业</li>
      <li class="text">企业金融</li>
      <li class="text">保险行业</li>
      <li class="text">地产行业</li>
      <li class="text">能源行业</li>
      <li class="text">汽车金融</li>
      <li class="text">智能终端测试</li>
      <li class="text"><router-link to="/solution">更多解决方案>></router-link></li>
    </ul>
    <ul class="forth list">
        <li class="title" s18n-common="">关于橡诺</li>
        <li class="text"><router-link to="/about">公司简介</router-link></li>
        <!-- <li class="text"><router-link to="/">发展历程</router-link></li> -->
        <li class="text"><router-link to="/honor">企业荣誉</router-link></li>
        <li class="text"><router-link to="/contacts">联系我们</router-link></li>
    </ul>
    <ul class="three list en-hide">
      <li class="title">&nbsp;</li>
    </ul>
    
    <ul class="list">
        <li class="title" s18n-common="">全国服务热线</li>
        <li class="text"><a class="phone">173 1718 1516</a></li>
        <li class="text"><span s18n-common="">周一到周五：9:00-19:00</span></li>
        <li class="text"><span s18n-common="">周六：9:00-17:30</span></li>
        <li class="text"><img class="qr" src="@/assets/img/qr-code.png" alt="微信联系"></li>
        <li class="text"><span s18n-common="">关注橡诺科技</span></li>
    </ul>

    <section class="other en-hide">
      <div class="des">
        <div class="inline">
        友情链接:
        <a href="https://www.alibabagroup.com">阿里巴巴 | </a>
        <a href="https://www.aliyun.com/">阿里云 | </a>
        <a href="https://www.dingtalk.com/">钉钉 </a>
        </div>
        <div class="inline right">
          <div id="footer-copyright">@Copyright 2012 - 2020 | 上海橡诺科技有限公司 沪ICP备14053876号</div>
        </div>
      </div>
    </section>
  </section>
</section>
</template>

<script>
export default {
  name: '',
  props: {
    
  }
}
</script>

<style scoped lang="less">
.footer-wrapper {
    height: 440px;
    background: #273036;
    padding-top: 2.6%;
    font-size: 0;
    .footer {
        width: 1200px;
        margin-right: auto;
        margin-left: auto;
        .list {
            display: inline-block;
            width: 20%;
            padding: 0;
            text-align: left;
            vertical-align: top;
            .qr{
              width: 64px;
            }
            .phone {
                opacity: .7;
                font-size: 24px;
                color: #fafafa;
            }
        }
        .other {
            font-size: 14px;
            color: #aaa;
            margin-top: 54px;
            a {
                // display: inline-block;
                text-decoration: none;
                font-size: 14px;
                color: #aaa;
            }
            .des {
                position: relative;
                padding-top: 19px;
                border-top: .5px solid rgba(255,255,255,.4);
            }
            .right {
                position: absolute;
                right: 0;
                a {
                    margin-left: 12px;
                    vertical-align: middle;
                }
            }
            #footer-copyright {
                display: inline-block;
            }
        }
        .title {
            opacity: .7;
            font-size: 18px;
            color: #fafafa;
            list-style: none;
            padding-bottom: 21px;
        }
        .text {
            margin-bottom: 8px;
            font-size: 14px;
            color: rgba(255,255,255,.4);
            list-style: none;
            a {
                text-decoration: none;
                font-size: 14px;
                color: rgba(255,255,255,.4);
                list-style: none;
            }
            a:hover {
                color: #fefcfc;
            }
            span {
                font-size: 14px;
                color: rgba(255,255,255,.4);
                list-style: none;
            }
        }
    }
}
</style>
